import { ARReportsConstants } from '../cirabooks/transition-ar-reports/_constants/ar-reports-constant';
import { LotUnitConstants } from '../lotunit-tools-module/_constants/lotunit-constants';

const routesData = {
    '/tools/:communityId/logphonecall': {
        anonymousAccess: false,
        newWindow: true,
        resizable: true,
        outletOnly: true,
        width: LotUnitConstants.logCallPopupWindowWidth,
        height: LotUnitConstants.logCallPopupWindowHeight,
        title: 'Log Call / Create Case',
        accessCode: 'TOOLS_LOG_CALL'
    },
    '/cb/:communityId/ar/transitionreports/all-balances': {
        anonymousAccess: false,
        newWindow: true,
        resizable: true,
        outletOnly: true,
        width: ARReportsConstants.arReportsPopupWindowHeight,
        height: ARReportsConstants.arReportsPopupWindowHeight,
        title: 'AR Transition Reports All Balances',
        accessCode: 'AR_TRANSITION_REPORTS_ALL_BALANCES'
    },
    '/cb/:communityId/ar/transitionreports/credit-balances': {
        anonymousAccess: false,
        newWindow: true,
        resizable: true,
        outletOnly: true,
        width: ARReportsConstants.arReportsPopupWindowHeight,
        height: ARReportsConstants.arReportsPopupWindowHeight,
        title: 'AR Transition Reports Credit Balances',
        accessCode: 'AR_TRANSITION_REPORTS_CREDIT_BALANCES'
    },
    '/cb/:communityId/ar/transitionreports/debit-balances': {
        anonymousAccess: false,
        newWindow: true,
        resizable: true,
        outletOnly: true,
        width: ARReportsConstants.arReportsPopupWindowHeight,
        height: ARReportsConstants.arReportsPopupWindowHeight,
        title: 'AR Transition Reports Debit Balances',
        accessCode: 'AR_TRANSITION_REPORTS_DEBIT_BALANCES'
    },
    '/cb/:communityId/ar/transitionreports/debit-credit-balances': {
        anonymousAccess: false,
        newWindow: true,
        resizable: true,
        outletOnly: true,
        width: ARReportsConstants.arReportsPopupWindowHeight,
        height: ARReportsConstants.arReportsPopupWindowHeight,
        title: 'AR Transition Reports Debit And Credit Balances',
        accessCode: 'AR_TRANSITION_REPORTS_DEBIT_CREDIT_BALANCES'
    },
    '/cb/:communityId/ar/transitionreports/zero-balances': {
        anonymousAccess: false,
        newWindow: true,
        resizable: true,
        outletOnly: true,
        width: ARReportsConstants.arReportsPopupWindowHeight,
        height: ARReportsConstants.arReportsPopupWindowHeight,
        title: 'AR Transition Reports Zero Balances',
        accessCode: 'AR_TRANSITION_REPORTS_ZERO_BALANCES'
    }
};

export class RouteDataConstants {
    static getRouteDataByPath(path: string) {
        const data = routesData[path];
        return !!data ? { data } : null;
    }
}
